(() => {
  'use strict';

  document.addEventListener('DOMContentLoaded', () => {
    const block = document.querySelector('.services-list');
    if (!block) return;

    const input = block.querySelector('.search-input input');
    const btn = block.querySelector('.search-btn');
    const grid = block.querySelector('.grid');
    const items = Array.from(block.querySelectorAll('.grid li'));
    const noResults = block.querySelector('.no-results');

    const config = window.searhcSearch || null;
    const hasSmartSearch = !!(config && config.restUrl);
    let smartController = null;


    //////////////////////////////////////
    // INSTANT FILTER (substring on data-search)
    const instantFilter = (term) => {
      let visible = 0;
      items.forEach((item) => {
        const data = item.getAttribute('data-search') || '';
        const match = !term || data.includes(term);
        item.classList.toggle('hidden', !match);
        if (match) visible++;
      });
      if (noResults) noResults.style.display = visible === 0 ? 'block' : 'none';
      return visible;
    };


    //////////////////////////////////////
    // SMART SEARCH (reorder + filter by returned IDs)
    const smartSearch = async (term) => {
      if (!hasSmartSearch || !term) return;

      if (smartController) smartController.abort();
      smartController = new AbortController();

      try {
        const res = await fetch(`${config.restUrl}?q=${encodeURIComponent(term)}`, {
          signal: smartController.signal,
          headers: { 'X-WP-Nonce': config.nonce },
        });
        if (!res.ok) return;
        const data = await res.json();

        if (!data.available || !Array.isArray(data.ids) || data.ids.length === 0) {
          return;
        }

        const ids = data.ids.map(String);
        const byId = new Map(items.map((el) => [el.getAttribute('data-id'), el]));

        let visible = 0;
        ids.forEach((id) => {
          const el = byId.get(id);
          if (el) {
            el.classList.remove('hidden');
            grid.appendChild(el);
            visible++;
          }
        });

        items.forEach((el) => {
          if (!ids.includes(el.getAttribute('data-id'))) {
            el.classList.add('hidden');
          }
        });

        if (noResults) noResults.style.display = visible === 0 ? 'block' : 'none';
      } catch (err) {
        if (err.name !== 'AbortError') {
          // Silent fallback — instant filter already ran
        }
      }
    };


    //////////////////////////////////////
    // DEBOUNCE
    let debounceTimer = null;
    const debouncedSmart = (term) => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => smartSearch(term), 300);
    };


    //////////////////////////////////////
    // EVENTS
    const handleInput = () => {
      const term = input.value.toLowerCase().trim();
      instantFilter(term);
      debouncedSmart(term);
    };

    const handleSubmit = (e) => {
      e.preventDefault();
      clearTimeout(debounceTimer);
      const term = input.value.toLowerCase().trim();
      instantFilter(term);
      smartSearch(term);
    };

    input.addEventListener('input', handleInput);
    btn.addEventListener('click', handleSubmit);
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') handleSubmit(e);
    });
  });
})();
